import { ESwapType, ESymbolCategory } from '@aqx-core/common/api/market';
import { TAppLanguageISOCountryCode, i18n } from '@aqx-core/common/i18n';

export * from './option-symbol-name';

export const mapSymbolCategoryToLabel = (
  symbolCategory: ESymbolCategory | undefined | null,
  lng?: TAppLanguageISOCountryCode
) => {
  const SYMBOL_CATEGORY_MAP: Record<ESymbolCategory, string> = {
    [ESymbolCategory.FOREX]: i18n.t('Forex', { lng }),
    [ESymbolCategory.SHARES]: i18n.t('Shares', { lng }),
    [ESymbolCategory.COMMODITIES]: i18n.t('Commodities', { lng }),
    [ESymbolCategory.INDEX]: i18n.t('Index', { lng }),
    [ESymbolCategory.CRYPTO]: i18n.t('Crypto', { lng }),
    [ESymbolCategory.OTHERS]: i18n.t('Others', { lng }),
    [ESymbolCategory.FUTURES]: i18n.t('Futures', { lng }),
    [ESymbolCategory.OPTION]: i18n.t('Options', { lng }),
    [ESymbolCategory.EQUITIES]: i18n.t('Equities', { lng }),
    [ESymbolCategory.ETFS]: i18n.t('ETFs', { lng }),
    [ESymbolCategory.ALL]: i18n.t('All', { lng })
  };
  if (!symbolCategory) {
    return '--';
  }
  return SYMBOL_CATEGORY_MAP[symbolCategory];
};

export const mapSwapTypeToLabel = (swapType: ESwapType | undefined | null, lng?: TAppLanguageISOCountryCode) => {
  const SWAP_TYPE_TEXT_MAP: Record<ESwapType, string> = {
    [ESwapType.SWAP_BY_POINTS]: i18n.t('in points', { lng }),
    [ESwapType.SWAP_BY_DOLLARS]: i18n.t('in money, using base currency', { lng }),
    [ESwapType.SWAP_BY_INTEREST]: i18n.t('in percentage term', { lng }),
    [ESwapType.SWAP_BY_MARGIN_CURRENCY]: i18n.t('in money, using margin currency', { lng }),
    [ESwapType.SWAP_DISABLED]: '-',
    [ESwapType.SWAP_BY_SYMBOL_CURRENCY]: i18n.t('in money, using margin currency', { lng }),
    [ESwapType.SWAP_BY_GROUP_CURRENCY]: i18n.t('in money, using group currency', { lng }),
    [ESwapType.SWAP_BY_INTEREST_CURRENT]: i18n.t('in percentage terms, using current price', { lng }),
    [ESwapType.SWAP_BY_INTEREST_OPEN]: i18n.t('in percentage terms, using open price', { lng }),
    [ESwapType.SWAP_REOPEN_BY_CLOSE_PRICE]: i18n.t('in points, reopen position by close price', { lng }),
    [ESwapType.SWAP_REOPEN_BY_BID]: i18n.t('in points, reopen position by bid price', { lng }),
    [ESwapType.SWAP_BY_PROFIT_CURRENCY]: i18n.t('in money, using profit currency', { lng }),
    [ESwapType.SWAP_FIXED_MONEY_PER_LOT]: i18n.t('fixed money per lot', { lng }),
    [ESwapType.SWAP_BY_POINT_CENTROID]: i18n.t('in points', { lng }),
    [ESwapType.SWAP_BY_PRICE_PERCENTAGE]: i18n.t('in percentage', { lng })
  };

  if (!swapType && swapType !== 0) {
    return '--';
  }

  return SWAP_TYPE_TEXT_MAP[swapType];
};
